function initEmptyDrawerStates(root = document) {
  const blocks = root.querySelectorAll('[data-empty-drawer-state]');

  blocks.forEach((block) => {
    if (block.dataset.emptyDrawerInitialized === 'true') return;

    const raw = block.getAttribute('data-images');
    if (!raw) return;

    let items = [];

    try {
      items = JSON.parse(raw);
    } catch (e) {
      return;
    }

    items = items.filter((item) => item && item.src);

    if (!items.length) return;

    const mediaWrap = block.querySelector('[data-empty-drawer-media]');
    if (!mediaWrap) return;

    const chosen = items[Math.floor(Math.random() * items.length)];

    const img = document.createElement('img');
    img.src = chosen.src;
    img.alt = chosen.alt || '';
    img.loading = 'lazy';
    img.className = 'empty-drawer-state__image';

    if (chosen.href) {
      const link = document.createElement('a');
      link.href = chosen.href;
      link.className = 'empty-drawer-state__image-link';
      link.appendChild(img);
      mediaWrap.appendChild(link);
    } else {
      mediaWrap.appendChild(img);
    }

    block.dataset.emptyDrawerInitialized = 'true';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initEmptyDrawerStates();

  const predictiveSearch = document.querySelector('#predictive-search');

  if (predictiveSearch) {
    const observer = new MutationObserver(() => {
      initEmptyDrawerStates(predictiveSearch);
    });

    observer.observe(predictiveSearch, {
      childList: true,
      subtree: true
    });
  }
});